import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/meta-logo.webp'
import _imports_1 from '../assets/wechat-ai.jpg'
import _imports_2 from '../assets/wechat-sunwen-2.jpg'
import _imports_3 from '../assets/xiaohongshu-qrcode.png'
import _imports_4 from '../assets/toutiaoqrcode.png'
import _imports_5 from '../assets/weiboqrcode.png'


const _withScopeId = n => (_pushScopeId("data-v-18facd46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "meta-footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "meta-logo",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "footer-content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-content-column footer-content-address\" data-v-18facd46><div class=\"fcc-wrapper\" data-v-18facd46><div class=\"fc-title\" data-v-18facd46>ADDRESS</div><p class=\"fc-desc\" data-v-18facd46><em class=\"fcd-head\" data-v-18facd46>秘塔 · 上海：</em>上海市徐汇区龙台路180号F2大楼3楼模速空间313室 </p><p class=\"fc-desc\" data-v-18facd46><em class=\"fcd-head\" data-v-18facd46>秘塔 · 北京：</em>北京市朝阳区远洋国际中心C座2604 </p><p class=\"fc-desc\" data-v-18facd46><em class=\"fcd-head\" data-v-18facd46>秘塔 · 成都：</em>成都高新区天府二街368号绿地之窗2栋1212 </p></div></div><div class=\"footer-content-column footer-content-contact\" data-v-18facd46><div class=\"fcc-wrapper\" data-v-18facd46><div class=\"fc-title\" data-v-18facd46>CONTACT US</div><p class=\"fc-desc\" data-v-18facd46><em class=\"fcd-head\" data-v-18facd46>联系微信：</em>metasota02 </p><p class=\"fc-desc\" data-v-18facd46><em class=\"fcd-head\" data-v-18facd46>邮箱：</em><a class=\"fc-email\" href=\"mailto:wutingting@metasota.ai\" data-v-18facd46>wutingting@metasota.ai</a></p><p class=\"fc-desc\" data-v-18facd46><em class=\"fcd-head\" data-v-18facd46>电话：</em>17610899961 </p></div></div>", 2)
const _hoisted_6 = { class: "footer-content-column footer-content-follow" }
const _hoisted_7 = { class: "fcc-wrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fc-title" }, "Follow Us On", -1))
const _hoisted_9 = { class: "fc-platforms" }
const _hoisted_10 = {
  class: "fc-platform weixin",
  ref: "weixin"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  class: "contact-popper",
  ref: "weixinPopper"
}
const _hoisted_13 = { class: "contact-popper-wrapper" }
const _hoisted_14 = {
  class: "contact-arrow",
  "data-popper-arrow": "",
  ref: "weixinArrow"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"QR-code-wrapper\" data-v-18facd46><img src=\"" + _imports_1 + "\" data-v-18facd46><p class=\"contact-qr-title\" data-v-18facd46>关注秘塔AI公众号</p></div><div class=\"QR-code-wrapper\" data-v-18facd46><img src=\"" + _imports_2 + "\" data-v-18facd46><p class=\"contact-qr-title\" data-v-18facd46>扫码联系我们</p></div>", 2)
const _hoisted_17 = {
  class: "fc-platform xiaohongshu",
  ref: "xiaohongshu"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  class: "contact-popper",
  ref: "xiaohongshuPopper"
}
const _hoisted_20 = { class: "contact-popper-wrapper" }
const _hoisted_21 = {
  class: "contact-arrow",
  "data-popper-arrow": "",
  ref: "xiaohongshuArrow"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "QR-code-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createElementVNode("p", { class: "contact-qr-title" }, "关注官方小红书")
], -1))
const _hoisted_23 = {
  class: "fc-platform toutiao",
  ref: "toutiao"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  class: "contact-popper",
  ref: "toutiaoPopper"
}
const _hoisted_26 = { class: "contact-popper-wrapper" }
const _hoisted_27 = {
  class: "contact-arrow",
  "data-popper-arrow": "",
  ref: "toutiaoArrow"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "QR-code-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
  /*#__PURE__*/_createElementVNode("p", { class: "contact-qr-title" }, "关注头条官方号")
], -1))
const _hoisted_29 = {
  class: "fc-platform weibo",
  ref: "weibo"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  class: "contact-popper",
  ref: "weiboPopper"
}
const _hoisted_32 = { class: "contact-popper-wrapper" }
const _hoisted_33 = {
  class: "contact-arrow",
  "data-popper-arrow": "",
  ref: "weiboArrow"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "QR-code-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }),
  /*#__PURE__*/_createElementVNode("p", { class: "contact-qr-title" }, "关注官方微博")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-bottom" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "footer-copyright" }, " © 2023 秘塔科技 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                class: "fc-platform-img",
                src: _ctx.platforms.weixin
              }, null, 8, _hoisted_11),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, null, 512),
                  _hoisted_15
                ])
              ], 512)
            ], 512),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("img", {
                class: "fc-platform-img",
                src: _ctx.platforms.xiaohongshu
              }, null, 8, _hoisted_18),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, null, 512),
                  _hoisted_22
                ])
              ], 512)
            ], 512),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("img", {
                class: "fc-platform-img",
                src: _ctx.platforms.toutiao
              }, null, 8, _hoisted_24),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, null, 512),
                  _hoisted_28
                ])
              ], 512)
            ], 512),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("img", {
                class: "fc-platform-img",
                src: _ctx.platforms.weibo
              }, null, 8, _hoisted_30),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, null, 512),
                  _hoisted_34
                ])
              ], 512)
            ], 512)
          ])
        ])
      ])
    ]),
    _hoisted_35
  ]))
}